import React, {useState, useEffect} from 'react'
import "./DeliveryTimeEdit.scss";
import { DatePicker } from '@livingdesign/react';
import EditFormActionsFooter from './EditFormActionsFooter';
import { useMessageDetailsForm } from '../../../../../contexts/MessageDetailsForm';
import RadioOption from '../../../common/RadioOption/RadioOption';
import InputErrorText from '../../../common/Error/InputErrorText';
// import { TimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import moment from 'moment';
import { TextField } from '@material-ui/core';
import { getDateFromCron } from '../../../../../utils/campaign';
import { getDate, validateTime } from '../../../../../utils/campaignEdit';

export const QA_ID_PREFIX = "DeliveryTimeEdit";

function DeliveryTimeEdit({
  stepIndex,
}) {

  const {
    formValues,
    Controller,
    errors,
    control,
    setValue,
    selectedCampaign,
    continueButtonLoading,
    handleContinue,
    handlePrevious,
    saveCampaign,
    saveDraft,
  } = useMessageDetailsForm();

  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  // const [selectedDate, setSelectedDate] = useState();

  useEffect(() => {
    if (formValues.deliveryType !== "scheduled") {
      setValue("scheduledDate", null);
      setValue("scheduledTime", null);
      setValue("scheduledDateTime", null);
    } else {
      let date = getDate(selectedCampaign);
      validateTime(date);
      setValue("scheduledDate", moment(date).startOf('day').toDate());
      setValue("scheduledTime", moment(date).format("HH:mm"));
    }
  }, [formValues.deliveryType]);


  return (
    <div data-testid={`${QA_ID_PREFIX}-root`}>
      <div className='delivery-time-edit-title' data-testid={`${QA_ID_PREFIX}-title`}>
        <h2 data-testid={`${QA_ID_PREFIX}-main-heading`}>Set delivery time for your message</h2>
        <p data-testid={`${QA_ID_PREFIX}-description`}>Choose to send your message immediately or schedule it for a specific date and time - ensuring it reaches recipients at the most effective moment.</p>
      </div>
      <div className='delivery-time-edit-form' data-testid={`${QA_ID_PREFIX}-form`}>
        <h3 data-testid={`${QA_ID_PREFIX}-personalise-heading`}>Do you want to personalise your message?</h3>
        <div className='delivery-type-radio-group' data-testid={`${QA_ID_PREFIX}-radio-group`}>
          <Controller
            name="deliveryType"
            control={control}
            rules={{ required: "Kindly schedule the delivery time." }}
            render={({ field }) => (
              <>
                <RadioOption
                  groupName={"isScheduledRadioGroup"}
                  a11yLabelledBy="is-scheduled-radio-custom-label"
                  label={"Send now"}
                  value={"send-now"}
                  checked={field.value === "send-now"}
                  onChange={(event) => {
                    field.onChange(event.target.value);
                    setIsCalendarOpen(false);
                  }}
                  disabled={continueButtonLoading}
                  data-testid={`${QA_ID_PREFIX}-radio-send-now`}
                />
                <RadioOption
                  groupName={"isScheduledRadioGroup"}
                  a11yLabelledBy="is-scheduled-radio-custom-label"
                  label={"Schedule for later"}
                  value={"scheduled"}
                  checked={field.value === "scheduled"}
                  onChange={(event) => {
                    field.onChange(event.target.value);
                  }}
                  disabled={continueButtonLoading}
                  data-testid={`${QA_ID_PREFIX}-radio-scheduled`}
                />
                {errors?.["deliveryType"]?.["message"] &&
                  <InputErrorText className="" message={errors?.["deliveryType"]["message"]} data-testid={`${QA_ID_PREFIX}-error-deliveryType`}/>
                }
                {field.value === "scheduled" &&
                  <div style={{marginTop: "24px"}} data-testid={`${QA_ID_PREFIX}-scheduled-section`}>
                    <Controller
                      name="scheduledDate"
                      control={control}
                      render={({ field }) => (
                        <DatePicker
                          isOpen={isCalendarOpen}
                          label="Choose date (mm/dd/yyyy)"
                          onClose={() => setIsCalendarOpen(false)}
                          onOpen={() => setIsCalendarOpen(true)}
                          onSelect={(value) => field.onChange(value)}
                          value={field.value}
                          defaultValue={new Date()}
                          format="MM/dd/yyyy"
                          minDate={new Date()}
                          disabled={continueButtonLoading}
                          data-testid={`${QA_ID_PREFIX}-datepicker`}
                        />
                      )}
                    />
                    {errors?.["scheduledDate"]?.["message"] &&
                      <InputErrorText className="" message={errors?.["scheduledDate"]["message"]} data-testid={`${QA_ID_PREFIX}-error-scheduledDate`}/>
                    }
                    <Controller
                      name={"scheduledTime"}
                      control={control}
                      render={({ field }) => (
                        <div className='delivery-time-edit-time-picker' style={{marginTop: "24px"}} data-testid={`${QA_ID_PREFIX}-time-picker`}>
                          <label style={{color: (continueButtonLoading) ? "#babbbe" : "#2e2f32"}} data-testid={`${QA_ID_PREFIX}-time-label`}>Choose time (00:00 AM or PM)</label>
                          <TextField
                            label={null}
                            type="time"
                            value={field.value}
                            onChange={(newValue) => field.onChange(newValue)}
                            variant="outlined"
                            disabled={continueButtonLoading}
                            data-testid={`${QA_ID_PREFIX}-textfield-time`}
                          />
                        </div>
                      )}
                    />
                    {errors?.["scheduledTime"]?.["message"] &&
                      <InputErrorText className="" message={errors?.["scheduledTime"]["message"]} data-testid={`${QA_ID_PREFIX}-error-scheduledTime`}/>
                    }
                    {errors?.["scheduledDateTime"]?.["message"] &&
                      <InputErrorText className="" message={errors?.["scheduledDateTime"]["message"]} data-testid={`${QA_ID_PREFIX}-error-scheduledDateTime`}/>
                    }
                  </div>
                }
              </>
            )}
          />
        </div>
        <EditFormActionsFooter
          loading={continueButtonLoading}
          onPrevious={() => handlePrevious()}
          onSaveDraft={() => saveDraft()}
          onContinue={() => handleContinue(stepIndex)}
          data-testid={`${QA_ID_PREFIX}-actions-footer`}
        />
      </div>
    </div>
  )
}

export default DeliveryTimeEdit;